<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">库存模块</el-breadcrumb-item>
                <el-breadcrumb-item>借出业务</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <section ref="print" id="print-panel">
            <el-form :model="dto.borrowed" :rules="rules" ref="borrowed" label-width="120px">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="申请单号" prop="billCode">
                            <el-input v-model="dto.borrowed.billCode" :disabled="true"
                                style="max-width: 220px;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="申请类型" prop="billType">
                            <el-input v-model="dto.borrowed.billType" :disabled="true"
                                style="max-width: 220px;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="制单日期" prop="billDate">
                            <el-date-picker v-model="dto.borrowed.billDate" type="date" :disabled="isView"
                                style="width:220px"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="外部编号" prop="netCode">
                            <el-input v-model="dto.borrowed.netCode" :disabled="isView" style="width:220px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="所属公司" prop="companyID">
                            <el-tree-select ref="companys" v-model="dto.borrowed.companyID" :data="companys"
                                :disabled="isView || !!dto.apps.length > 0" check-strictly
                                :render-after-expand="false" style="width: 280px;" />
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="操作人" prop="operatorName">
                            <el-input v-model="dto.borrowed.operatorName" :disabled="isView"
                                style="width:180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="制单人" prop="createUserName">
                            <el-input v-model="dto.borrowed.createUserName" disabled style="width:180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="借货单" prop="">
                            <div style="display:flex;align-items:center;">
                                <el-text v-if="dto.borrowed.status == 0" type="primary" disabled>待领导审核</el-text>
                                <el-text v-else-if="dto && dto.borrowed.status == 11" type="primary"
                                    disabled>待供应链审核</el-text>
                                <el-text v-else-if="dto && dto.borrowed.status == 1" type="success"
                                    disabled>已审核</el-text>
                                <el-text v-else-if="dto && dto.borrowed.status == -1" type="danger"
                                    disabled>已取消</el-text>
                                <el-text v-else type="info" disabled></el-text>
                            </div>
                            <div style="display:flex;align-items:center; margin-left: 20px;">
                                <el-text type="info" disabled>还货单：</el-text>
                                <el-text v-if="dto && dto.returned && dto.returned.status == 0" type="primary"
                                    disabled>待审核</el-text>
                                <el-text v-else-if="dto && dto.returned && dto.returned.status == 1" type="success"
                                    disabled>已审核</el-text>
                                <el-text v-else-if="dto && dto.returned && dto.returned.status == -1" type="danger"
                                    disabled>已取消</el-text>
                                <el-text v-else type="info" disabled></el-text>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6">
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="12" :md="6">
                        <el-form-item label="预计归还时间" prop="completionDate">
                            <el-date-picker v-model="dto.borrowed.completionDate" type="date" :disabled="isEdit"
                                style="width:220px"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24">
                        <el-form-item label="备注/原因" prop="remark">
                            <el-input v-model="dto.borrowed.remark" type="textarea" :rows="2" :disabled="isView"
                                placeholder="请输入备注/原因/预计归还日期等"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>


            <div style="display:flex;align-items:center;justify-content:space-between; margin-bottom: 10px;">
                <div> </div>
                <div>
                    <el-button plain icon="Plus" type="primary" size="small" @click="addDetail"
                        :disabled="isView || isEdit">
                        新增明细
                    </el-button>

                    <el-button plain icon="Promotion" type="primary" size="small" @click="departBound"
                        :disabled="dto.borrowed.status != 0">
                        领导审核
                    </el-button>

                    <el-button plain icon="Promotion" type="success" size="small" @click="scanBound"
                        :disabled="dto.borrowed.status != 11">
                        供应链扫码
                    </el-button>
                    <el-button plain icon="Promotion" type="success" size="small" @click="auditBound"
                        :disabled="dto.borrowed.status != 11">
                        确认借出
                    </el-button>

                    <el-button plain icon="Bottom" type="info" size="small" @click="returnBorrow"
                        :disabled="!(dto.returned && (dto.returned.status == 0 || dto.returned.status == 1))">
                        借出归还
                    </el-button>

                    <el-button plain icon="Printer" size="small" @click="printForms" :disabled="isView">
                        打印
                    </el-button>

                    <!-- <el-dropdown v-if="!isView" style="margin:0px 10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    数据操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item :disabled="isEdit">导入明细</el-dropdown-item>
                                        <el-dropdown-item>下载模板</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown> -->
                </div>
            </div>


            <el-tabs type="border-card" v-model="tabName">
                <el-tab-pane name="preTable">
                    <template #label>
                        <span>预借出货品 {{ dto.apps.length }}</span>
                    </template>

                    <el-table class="table" :data="dto.apps" border style="width: 100%" highlight-current-row
                        size="small" show-summary @selection-change="handleAppsSelectionChange">
                        <el-table-column type="selection" width="50" align="center" />
                        <el-table-column label="序号" type="index" width="50" align="center"> </el-table-column>
                        <el-table-column prop="channel" label="渠道" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="storeName" label="库房" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column prop="serialCode" label="批次号" align="center" sortable width="120">
                        </el-table-column>

                        <el-table-column prop="detailCode" label="系统款号" width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="certNumber" label="证书号" width="100" align="center"
                            show-overflow-tooltip></el-table-column>

                        <el-table-column prop="detailName" label="名称" sortable width="180" align="center"
                            show-overflow-tooltip></el-table-column>

                        <el-table-column prop="brandCode" label="供应商" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="detailCode" label="图片" align="center" width="70">
                            <template #default="scope">
                                <el-image style="height: 32px; width: 32px" lazy
                                    :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                                    :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                    <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg"
                                            alt="" /></template>
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="stockNumber" label="借出数量" align="right" width="105">
                            <template #default="scope">
                                <el-input-number v-if="!isEdit" v-model="scope.row.stockNumber" :min="0.01" :max="99999"
                                    size="small" style="width: 80px;" controls-position="right">
                                </el-input-number>
                                <span v-else>{{ scope.row.stockNumber }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="stockRemain" label="最大可借" align="right" width="70"> </el-table-column>

                        <el-table-column prop="labelPrice" label="标签价" align="right" width="65"> </el-table-column>

                        <el-table-column prop="weight" label="货重(g)" align="right" width="65"> </el-table-column>
                        <el-table-column prop="goldWeight" label="金重(g)" align="right" width="65"> </el-table-column>

                        <el-table-column prop="unitName" label="规格" align="center" width="65"
                            show-overflow-tooltip></el-table-column>

                        <el-table-column prop="productPrice" width="70" align="right" label="入库价"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="sellPrice" width="70" align="right" label="售价"> </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
                        <el-table-column label="状态" width="90" align="center" fixed="right" v-if="!isView">
                            <template #default="scope">
                                <el-tooltip placement="left" v-if="scope.row.status == '0'" content="申请人预借货品，暂未出库">
                                    <el-button plain type="primary" size="small">预借货</el-button>
                                </el-tooltip>
                                <el-tooltip placement="left" v-if="scope.row.status == '5'"
                                    content="库管扫码替换的实际预借货品，暂未出库">
                                    <el-button plain type="success" size="small">已替换</el-button>
                                </el-tooltip>
                                <el-tooltip placement="left" v-else-if="scope.row.status == '1'" content="已借出的货品，已操作出库">
                                    <el-button plain type="info" size="small">已出库</el-button>
                                </el-tooltip>
                                <el-tooltip placement="left" v-else-if="scope.row.status == '-1'"
                                    content="已取消的借出，明细借出取消，操作取消">
                                    <el-button plain type="warning" size="small">已取消</el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="130" align="center" fixed="right" v-if="!isView">
                            <template #default="scope">
                                <el-button type="success" plain size="small"
                                    :disabled="(scope.row.status || '0') != '5'" style="margin-left:5px;"
                                    @click="resetDetail(scope.row.id)">重置</el-button>
                                <el-button type="warning" plain size="small"
                                    :disabled="!(scope.row.id && ((scope.row.status || '0') == '0' || (scope.row.status || '0') == '5'))"
                                    style="margin-left:5px;" @click="deleteDetail(scope.row.id)">取消</el-button>
                                <el-button type="danger" size="small"
                                    v-if="(scope.row.status || '0') == '0' && !isEdit && !scope.row.id"
                                    :disabled="isEdit" @click="removeDetail(scope.$index)">移除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <el-tab-pane name="outTable">
                    <template #label>
                        <span>已借出货品 {{ dto.outs.length }}</span>
                    </template>

                    <el-table class="table" :data="dto.outs" border style="width: 100%" highlight-current-row
                        size="small" show-summary>
                        <el-table-column label="序号" type="index" width="50" align="center"> </el-table-column>
                        <el-table-column prop="channel" label="渠道" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="storeCode" label="库房" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="serialCode" label="批次号" align="center" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="detailCode" label="系统款号" width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="certNumber" label="证书号" width="100" align="center" show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column prop="detailName" label="名称" sortable width="180" align="center"
                            show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column prop="brandCode" label="供应商" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="detailCode" label="图片" align="center" width="70">
                            <template #default="scope">
                                <el-image style="height: 32px; width: 32px" lazy
                                    :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                                    :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                    <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg"
                                            alt="" /></template>
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="stockNumber" label="操作数" align="right" width="55"> </el-table-column>
                        <el-table-column prop="stockOrigin" label="借出数" align="right" width="55"> </el-table-column>
                        <el-table-column prop="stockRemain" label="待还数" align="right" width="55"> </el-table-column>
                        <el-table-column prop="labelPrice" label="标签价" align="right" width="65"> </el-table-column>

                        <el-table-column prop="weight" label="克重(g)" align="right" width="65"> </el-table-column>

                        <el-table-column prop="goldWeight" label="金重(g)" align="right" width="65"> </el-table-column>
                        <el-table-column prop="goldInPrice" label="金单价" align="right" width="65"> </el-table-column>
                        <el-table-column prop="laborUnitPrice" label="克工费" align="right" width="65"> </el-table-column>
                        <el-table-column prop="laborPiecePrice" label="件工费" align="right" width="65"> </el-table-column>

                        <el-table-column prop="unitName" label="规格" align="center" width="65"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="noTaxPurchasePrice" width="95" label="不含税采购价" align="right"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxPrice" width="70" label="税额" align="right"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="purchasePrice" width="90" label="含税采购价" align="right"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="productPrice" width="75" align="right" label="入库价"> </el-table-column>
                        <el-table-column prop="sellPrice" width="75" align="right" label="售价"> </el-table-column>
                        <el-table-column prop="outOrderNo" label="原单号" width="120" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="productionDate" label="生产日期" show-overflow-tooltip>
                            <template #default="scope">
                                {{ (scope.row.productionDate || '').split(' ')[0] }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="warrantyExpiryDate" label="有效日期" show-overflow-tooltip>
                            <template #default="scope">
                                {{ (scope.row.warrantyExpiryDate || '').split(' ')[0] }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
                        <el-table-column label="操作" width="120" align="center" fixed="right" v-if="!isView">
                            <template #default="scope">
                                <el-tag v-if="scope.row.stockStatus == 'borrowed'" type="danger" size="small">待还{{
                                    scope.row.stockRemain }}</el-tag>
                                <el-tag v-else-if="scope.row.stockStatus == 'returned'" type="success"
                                    size="small">已还</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <el-tab-pane name="retTable">
                    <template #label>
                        <span>已退回货品 {{ dto.rets.length }}</span>
                    </template>

                    <el-table class="table" :data="dto.rets" border style="width: 100%" highlight-current-row
                        size="small" show-summary>
                        <el-table-column label="序号" type="index" width="50" align="center"> </el-table-column>
                        <el-table-column prop="channel" label="渠道" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="storeCode" label="库房" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="serialCode" label="批次号" align="center" sortable width="120">
                        </el-table-column>
                        <el-table-column prop="detailCode" label="系统款号" width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="certNumber" label="证书号" width="100" align="center" show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column prop="detailName" label="名称" sortable width="180" align="center"
                            show-overflow-tooltip>
                        </el-table-column>

                        <el-table-column prop="brandCode" label="供应商" width="70" align="center" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="detailCode" label="图片" align="center" width="70">
                            <template #default="scope">
                                <el-image style="height: 32px; width: 32px" lazy
                                    :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                                    :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                                    <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg"
                                            alt="" /></template>
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="stockNumber" label="数量" align="right" width="55"> </el-table-column>
                        <el-table-column prop="labelPrice" label="标签价" align="right" width="65"> </el-table-column>

                        <el-table-column prop="weight" label="克重(g)" align="right" width="65"> </el-table-column>

                        <el-table-column prop="goldWeight" label="金重(g)" align="right" width="65"> </el-table-column>
                        <el-table-column prop="goldInPrice" label="金单价" align="right" width="65"> </el-table-column>
                        <el-table-column prop="laborUnitPrice" label="克工费" align="right" width="65"> </el-table-column>
                        <el-table-column prop="laborPiecePrice" label="件工费" align="right" width="65"> </el-table-column>

                        <el-table-column prop="unitName" label="规格" align="center" width="65"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="noTaxPurchasePrice" width="95" label="不含税采购价" align="right"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxPrice" width="70" label="税额" align="right"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="purchasePrice" width="90" label="含税采购价" align="right"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="productPrice" width="75" align="right" label="入库价"> </el-table-column>
                        <el-table-column prop="sellPrice" width="75" align="right" label="售价"> </el-table-column>
                        <el-table-column prop="outOrderNo" label="原单号" width="120" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="productionDate" label="生产日期" show-overflow-tooltip>
                            <template #default="scope">
                                {{ (scope.row.productionDate || '').split(' ')[0] }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="warrantyExpiryDate" label="有效日期" show-overflow-tooltip>
                            <template #default="scope">
                                {{ (scope.row.warrantyExpiryDate || '').split(' ')[0] }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>

            <div style="text-align:center;margin-top:20px;">
                <el-button type="primary" @click="submit" :disabled="isEdit">保存</el-button>
                <!-- <el-button type="primary" @click="auditBound" v-if="isEdit">审核出库</el-button> -->
                <el-button @click="back">返回</el-button>
            </div>
        </section>

        <!-- 新增明细弹框 -->
        <el-dialog title="新增借出明细" v-model="showAddDialog" style="max-width:1200px; width: 100%;" destroy-on-close>
            <el-form :model="searchForm" label-width="110px">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="货品批次号">
                            <el-input v-model="searchForm.serialCode" placeholder="请输入批次号" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="系统款号">
                            <el-input v-model="searchForm.detailCode" placeholder="请输入系统款号" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="品牌款号">
                            <el-input v-model="searchForm.brandModelCode" placeholder="请输入品牌款号" clearable
                                @keyup.enter="searchStock"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所属公司">
                            <el-tree-select ref="companys" v-model="dto.borrowed.companyID" :data="companys" clearable
                                check-strictly :render-after-expand="false" style="min-width: 200px;" disabled />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="库房">
                            <el-select v-model="searchForm.storeCode" placeholder="请选择库房" clearable style="width:100%">
                                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="渠道">
                            <el-select v-model="searchForm.channel" placeholder="请选择渠道" clearable style="width:100%">
                                <el-option v-for="item in dict.channels" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="text-align:center;">
                        <el-button type="primary" icon="Search" @click="searchStock"
                            :loading="searchLoading">查询货品</el-button>
                        <el-button @click="resetSearchForm">重置</el-button>
                        <el-button type="success" icon="Plus" @click="batchAddToList"
                            :disabled="searchSelectedItems.length === 0">批量借货 ({{ searchSelectedItems.length
                            }})</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-divider></el-divider>

            <!-- 查询结果表格 -->
            <el-table :data="searchResults" border style="width: 100%; margin-top: 10px;" size="small" max-height="400"
                v-loading="searchLoading" @selection-change="handleSearchSelectionChange">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column prop="serialCode" label="批次号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailCode" label="系统款号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailName" label="货品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="storeCode" label="库房" width="70" align="center"></el-table-column>
                <el-table-column prop="channel" label="渠道" width="70" align="center"></el-table-column>
                <el-table-column prop="stockDate" label="入库时间" width="100" align="center">
                    <template #default="scope">
                        {{ (scope.row.stockDate || '').split(' ')[0] }}
                    </template>
                </el-table-column>
                <el-table-column prop="stockRemain" label="库存数量" width="70" align="center"></el-table-column>
            </el-table>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showAddDialog = false">取消</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 借出归还弹框 -->
        <el-dialog title="借出归还" v-model="showReturnDialog" style="max-width:1200px; width: 100%;" destroy-on-close>
            <!-- 阻止回车提交导致页面刷新 -->
            <el-form :model="returnForm" label-width="110px" @submit.prevent>
                <el-row :gutter="20">
                    <el-col :span="16">
                        <el-form-item label="条码扫描">
                            <el-input ref="serialCodeInput" v-model="returnForm.serialCode" placeholder="请扫描或输入条码"
                                clearable @keyup.enter.prevent="searchReturnStock" @input="onSerialCodeInput">
                                <template #append>
                                    <el-button icon="Search" @click="searchReturnStock"
                                        :loading="returnSearchLoading">查询</el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-button type="success" @click="clearReturnForm">清空</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-divider></el-divider>

            <!-- 待归还货品表格 -->
            <div style="margin-bottom: 10px;">
                <span style="font-weight: bold;">待归还货品列表 ({{ returnResults.length }}) - 已选择 {{
                    returnSelectedItems.length }}
                    项</span>
            </div>
            <el-table :data="returnResults" border style="width: 100%; margin-top: 10px;" size="small" max-height="400"
                v-loading="returnSearchLoading" @selection-change="handleReturnSelectionChange">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
                <el-table-column prop="serialCode" label="批次号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailCode" label="系统款号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="brandModelCode" label="品牌款号" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="detailName" label="货品名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="storeCode" label="库房" width="80" align="center"></el-table-column>
                <el-table-column prop="channel" label="渠道" width="80" align="center"></el-table-column>
                <el-table-column prop="borrowedQty" label="已借数量" width="70" align="right"></el-table-column>
                <el-table-column prop="returnedQty" label="已还数量" width="70" align="right"></el-table-column>
                <el-table-column prop="remainQty" label="剩余数量" width="70" align="right"></el-table-column>
                <el-table-column label="归还数量" width="120" align="center">
                    <template #default="scope">
                        <el-input-number v-model="scope.row.stockNumber" :min="1" :max="scope.row.remainQty"
                            size="small" style="width: 100px;" controls-position="right">
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                    <template #default="scope">
                        <el-button type="danger" link size="small"
                            @click="removeReturnItem(scope.$index)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showReturnDialog = false">取消</el-button>
                    <el-button type="primary" @click="confirmReturn" :disabled="returnSelectedItems.length === 0"
                        :loading="returnConfirmLoading">
                        确认归还 ({{ returnSelectedItems.length }})
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </el-card>
</template>

<script>
import printJS from "print-js";
import { fetchGroupBySerialCode } from "@/api/stock";
import { findCompanyById } from "@/api/basic";

export default {
    name: "borrow",
    components: {},
    data() {
        return {
            apiUrl: '',
            tabName: "preTable",

            billCode: null,
            dto: {
                borrowed: {
                    billType: '借货申请',
                },
                apps: [],
                outs: [],
                rets: [],
            },
            companys: [],

            // 新增明细弹框相关
            showAddDialog: false,
            searchForm: {
                serialCode: '',
                detailCode: '',
                brandModelCode: '',
                storeCode: '',
                channel: '',
            },
            searchResults: [],
            searchLoading: false,

            // 借出归还弹框相关
            showReturnDialog: false,
            returnForm: {
                serialCode: '',
            },
            returnResults: [],
            returnSearchLoading: false,
            returnConfirmLoading: false,
            returnSelectedItems: [],

            // dto.apps表格勾选数据
            appsSelectedItems: [],

            // searchResults表格勾选数据
            searchSelectedItems: [],

            // 字典数据
            dict: {
                stores: [],
                channels: [],
            },

            // 表单校验规则
            rules: {
                billCode: [
                    { required: true, message: '申请单号不能为空', trigger: 'blur' }
                ],
                billDate: [
                    { required: true, message: '申请日期不能为空', trigger: 'blur' }
                ],
                companyID: [
                    { required: true, message: '申请公司不能为空', trigger: 'blur' }
                ],
                completionDate: [
                    { required: true, message: '请填写预计归还日期', trigger: 'blur' }
                ],
                remark: [
                    { required: true, message: '请填写借出原因', trigger: 'blur' }
                ],
            },
        };
    },
    methods: {
        loadData() {
            if (this.billCode) {
                this.$kaung.fetch({
                    url: '/StockBills/BorrowDetail/' + this.billCode,
                    method: 'get'
                }).then((res) => {
                    if (res.code == 200) {
                        this.dto = res.data;
                    }
                });
                if (this.billCode.indexOf('-R') >= 0)
                    this.tabName = 'retTable';
            }
        },
        back() {
            this.$router.go(-1);
        },
        departBound() {
            this.$confirm('确定审核本次借出的货品？', '审核提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$kaung.fetch({
                    url: '/StockBills/ApproveBorrowByLeader/' + this.dto.borrowed.id,
                    method: 'post',
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.content || '审核成功');
                        this.loadData();
                    } else {
                        this.$message.error(res.content || '审核失败');
                    }
                });
            });
        },
        auditBound() {
            if (this.dto.apps.length == 0) {
                this.$message.warning('借出明细不能为空');
                return;
            }

            this.$confirm('确定审核本次借出的' + this.dto.apps.length + '件货品？', '提示：本次操作将直接出库', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$kaung.fetch({
                    url: '/StockBills/ApproveBorrow/' + this.dto.borrowed.id,
                    method: 'post',
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.content || '审核成功');
                        this.loadData();
                    } else {
                        this.$message.error(res.content || res.message || '审核失败');
                    }
                });
            }).catch(() => { });
        },
        // 供应链扫码
        scanBound() {
            // 检查是否有勾选数据
            if (!this.appsSelectedItems || this.appsSelectedItems.length === 0) {
                this.$message.warning('请先勾选需要扫码借出的货品数据行');
                return;
            }

            // 弹出输入框让用户输入批次号
            this.$prompt('本操作将替换预借货的批次信息，请输入或扫描实际出库货品批次号', '供应链扫码，确认实际出库批次号', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: '批次号不能为空',
                inputPlaceholder: '请输入批次号',
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '正在确认...';
                        const value = instance.inputValue;

                        if (!value || !value.trim()) {
                            this.$message.warning('批次号不能为空');
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = '确定';
                            return;
                        }

                        // 提取勾选数据的ID数组
                        const selectedIds = this.appsSelectedItems.map(item => item.id).filter(id => id);

                        if (selectedIds.length === 0) {
                            this.$message.warning('勾选的货品中没有有效的ID');
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = '确定';
                            return;
                        }

                        // 规范化批次号（支持逗号或空格分隔多个批次）
                        const serialCodes = (value || '').trim().replace(/\s+/g, ',').split(',').map(s => s.trim()).filter(s => s).join(',');

                        // 使用当前借货单号（优先使用 dto.borrowed.billCode）
                        const bill = this.dto && this.dto.borrowed && this.dto.borrowed.billCode ? this.dto.borrowed.billCode : this.billCode;

                        this.$kaung.fetch({
                            url: '/StockBills/ConfirmBorrow/' + (bill || ''),
                            method: 'post',
                            params: {
                                ids: selectedIds.join(','),
                                serialCodes: serialCodes
                            }
                        }).then((res) => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = '确定';
                            if (res.code === 200) {
                                this.$message.success(res.content || '确认成功');
                                // 刷新数据
                                this.loadData();
                                // 清空勾选
                                //this.appsSelectedItems = [];
                                done();
                            } else {
                                this.$message.error(res.content || res.message || '确认失败');
                            }
                        }).catch((error) => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = '确定';
                            console.error('确认失败:', error);
                            this.$message.error('确认失败，请稍后重试');
                        });
                    } else {
                        done();
                    }
                }
            }).then(({ value }) => {
                // 逻辑已移至 beforeClose
            }).catch(() => {
                // 用户取消输入
            });
        },
        // 处理dto.apps表格勾选变化
        handleAppsSelectionChange(selection) {
            this.appsSelectedItems = selection;
        },
        closeBound() { },

        // 打开新增明细弹框
        addDetail() {
            if (!this.dto.borrowed.companyID) {
                this.$message.warning('请先选择所属公司');
                return;
            }
            this.showAddDialog = true;
            this.searchResults = [];
            this.resetSearchForm();
        },

        // 重置搜索表单
        resetSearchForm() {
            this.searchForm = {
                serialCode: '',
                detailCode: '',
                brandModelCode: '',
                storeCode: '',
                channel: '',
            };
        },

        // 查询库存货品
        searchStock() {
            // fetchGroupBySerialCode 主要通过批次号查询，其他字段作为筛选条件
            // 至少需要填写批次号或其他筛选条件
            if (!this.searchForm.serialCode && !this.searchForm.detailCode && !this.searchForm.brandModelCode
                && !this.searchForm.storeCode && !this.searchForm.channel) {
                this.$message.warning('请至少填写一个查询条件（推荐填写批次号进行精确查询）');
                return;
            }

            this.searchLoading = true;
            this.searchResults = [];

            // 准备 fetchGroupBySerialCode 的参数
            // 根据 API 注释，serialCodes 是数组参数，用于按批次号分组查询
            const serialCodes = [];
            if (this.searchForm.serialCode) {
                // 支持逗号分隔的多个批次号
                const codes = this.searchForm.serialCode.split(',').map(code => code.trim()).filter(code => code);
                serialCodes.push(...codes);
            }

            // 使用 fetchGroupBySerialCode 接口查询库存（按批次号分组）
            fetchGroupBySerialCode(
                serialCodes, // serialCodes: Array<string> - 批次号数组，用于分组查询
                this.dto.borrowed.companyID || '', // companyID: string - 公司ID，限定公司库存
                this.searchForm.detailCode || '', // detailCode: string - 系统款号，按款号过滤
                this.searchForm.storeCode || '', // storeCode: string - 库房编码，限定库房
                this.searchForm.channel || '', // channel: string - 渠道编码，限定渠道
                this.searchForm.brandModelCode || '' // brandModelCode: string - 品牌款号，按款号过滤
            ).then((res) => {
                this.searchLoading = false;
                if (res.code === 200) {
                    // 过滤掉库存数量为0的记录
                    let queryResults = (res.data || []).filter(item => (item.stockRemain || 0) > 0);
                    if (queryResults.length === 0) {
                        this.$message.info('未找到符合条件的库存货品');
                    }
                    this.searchResults = this.searchResults.concat(queryResults);
                } else {
                    this.$message.error(res.content || res.message || '查询失败');
                }
            }).catch((error) => {
                this.searchLoading = false;
                console.error('查询库存失败:', error);
                this.$message.error('查询失败，请检查查询条件或稍后重试');
            });
        },

        // 处理searchResults表格勾选变化
        handleSearchSelectionChange(selection) {
            this.searchSelectedItems = selection;
        },

        // 批量添加到借出明细列表
        batchAddToList() {
            if (this.searchSelectedItems.length === 0) {
                this.$message.warning('请先勾选需要添加的货品');
                return;
            }

            let addedCount = 0;
            let duplicateCount = 0;

            this.searchSelectedItems.forEach(row => {
                // 检查是否已经添加过
                const exists = this.dto.apps.some(item =>
                    item.serialCode === row.serialCode &&
                    item.storeCode === row.storeCode &&
                    item.channel === row.channel
                );

                if (!exists) {
                    row.stockNumber = 1; // 默认借出数量为1
                    // 添加到预借出明细
                    this.dto.apps.push({
                        ...row,
                        brandSerialCode: row.serialCode,
                        storeName: row.storeCode,
                        random: Math.random(), // 用于唯一标识
                    });
                    addedCount++;
                } else {
                    duplicateCount++;
                }
            });

            // 从搜索结果中移除已添加的项
            this.searchResults = this.searchResults.filter(item => {
                return !this.searchSelectedItems.some(selected =>
                    selected.serialCode === item.serialCode &&
                    selected.storeCode === item.storeCode &&
                    selected.channel === item.channel
                );
            });

            // 清空选中项
            this.searchSelectedItems = [];

            // 提示消息
            if (addedCount > 0) {
                this.$message.success(`成功添加 ${addedCount} 件货品${duplicateCount > 0 ? `，${duplicateCount} 件重复已忽略` : ''}`);
            } else if (duplicateCount > 0) {
                this.$message.warning('选中的货品已在列表中，请勿重复添加');
            }
        },

        // 重置借货明细状态
        resetDetail(id) {
            this.$confirm('确定要重置该货品的确认状态吗？重置后将恢复为预借状态，可重新扫码替换预借货品。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const billCode = this.dto && this.dto.borrowed && this.dto.borrowed.billCode ? this.dto.borrowed.billCode : this.billCode;
                this.$kaung.fetch({
                    url: '/StockBills/ResetDetail/' + billCode,
                    method: 'post',
                    data: [id]
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.content || '重置成功');
                        this.loadData();
                    } else {
                        this.$message.error(res.content || res.message || '重置失败');
                    }
                });
            }).catch(() => { });
        },

        // 取消/删除借货明细
        deleteDetail(id) {
            this.$confirm('确定要取消该货品的借货明细吗？此操作将删除该明细记录。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const billCode = this.dto && this.dto.borrowed && this.dto.borrowed.billCode ? this.dto.borrowed.billCode : this.billCode;
                this.$kaung.fetch({
                    url: '/StockBills/DeleteDetail/' + billCode,
                    method: 'post',
                    data: [id]
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success(res.content || '取消成功');
                        this.loadData();
                    } else {
                        this.$message.error(res.content || res.message || '取消失败');
                    }
                });
            }).catch(() => { });
        },

        // 移除借出明细 不涉及接口
        removeDetail(index) {
            this.$confirm('确定要移除该货品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.dto.apps.splice(index, 1);
                this.$message.success('移除成功');
            }).catch(() => { });
        },

        // 打开借出归还弹框
        returnBorrow() {
            this.showReturnDialog = true;
            this.returnResults = [];
            this.returnSelectedItems = []; // 清空选中项
            this.clearReturnForm();

            // 弹框打开后聚焦到条码输入框
            this.$nextTick(() => {
                if (this.$refs.serialCodeInput) {
                    this.$refs.serialCodeInput.focus();
                }
            });
        },

        // 清空归还表单
        clearReturnForm() {
            this.returnForm = {
                serialCode: '',
            };
        },

        // 条码输入处理
        onSerialCodeInput(value) {
            // 如果输入的是完整条码(通常扫码枪会自动回车)，自动查询
            if (value && value.length >= 8) {
                // 延迟一下，避免扫码枪输入过快
                setTimeout(() => {
                    this.searchReturnStock();
                }, 100);
            }
        },

        // 查询待归还货品
        searchReturnStock() {
            if (!this.returnForm.serialCode.trim()) {
                this.$message.warning('请输入条码');
                return;
            }

            this.returnSearchLoading = true;

            // 调用接口查询该条码对应的借出货品
            this.$kaung.fetch({
                url: '/StockBills/GetBorrowReturnList',
                method: 'post',
                params: {
                    billCode: this.billCode,
                    serialCodes: this.returnForm.serialCode.trim()
                }
            }).then((res) => {
                this.returnSearchLoading = false;
                if (res.code === 200) {
                    const items = res.data.list;
                    items.forEach(item => {
                        if (item && item.remainQty > 0) {
                            // 检查是否已经在列表中
                            const exists = this.returnResults.some(existItem =>
                                existItem.serialCode === item.serialCode &&
                                existItem.storeCode === item.storeCode &&
                                existItem.channel === item.channel
                            );

                            if (exists) {
                                this.$message.warning('该货品已在归还列表中');
                            } else {
                                // 添加默认归还数量（最大可归还数量）
                                item.stockNumber = item.remainQty;
                                this.returnResults.push(item);
                                this.$message.success('添加成功');
                            }
                        } else if (item && item.remainQty <= 0) {
                            this.$message.info(item.serialCode + '该货品已全部归还');
                        } else {
                            this.$message.info('未找到对应的借出货品');
                        }
                    });

                    // 清空条码输入框，准备下一次扫描
                    this.returnForm.serialCode = '';
                    this.$nextTick(() => {
                        if (this.$refs.serialCodeInput) {
                            this.$refs.serialCodeInput.focus();
                        }
                    });
                } else {
                    this.$message.error(res.content || res.message || '查询失败');
                }
            }).catch((error) => {
                this.returnSearchLoading = false;
                console.error('查询归还货品失败:', error);
                //this.$message.error('查询失败，请稍后重试');
            });
        },

        // 移除归还项
        removeReturnItem(index) {
            this.$confirm('确定要移除该货品吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.returnResults.splice(index, 1);
                this.$message.success('移除成功');
            }).catch(() => { });
        },

        // 处理归还项选择变化
        handleReturnSelectionChange(selection) {
            this.returnSelectedItems = selection;
        },

        // 确认归还
        confirmReturn() {
            if (this.returnSelectedItems.length === 0) {
                this.$message.warning('请选择要归还的货品');
                return;
            }

            // 验证归还数量（只验证勾选的项）
            const invalidItems = this.returnSelectedItems.filter(item =>
                !item.stockNumber ||
                item.stockNumber <= 0 ||
                item.stockNumber > item.remainQty
            );

            if (invalidItems.length > 0) {
                this.$message.warning('请检查选中货品的归还数量是否有效（不能超过剩余可归还数量）');
                return;
            }

            this.$confirm(`确定归还选中的 ${this.returnSelectedItems.length} 件货品吗？`, '确认归还', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.returnConfirmLoading = true;

                // 调用后端归还接口（只提交勾选的数据）
                this.$kaung.fetch({
                    url: '/StockBills/ReturnBorrow/' + this.billCode,
                    method: 'post',
                    data: this.returnSelectedItems
                }).then((res) => {
                    this.returnConfirmLoading = false;
                    if (res.code === 200) {
                        this.$message.success('归还成功');

                        // 从returnResults中移除已归还的项
                        this.returnSelectedItems.forEach(selectedItem => {
                            const index = this.returnResults.findIndex(item =>
                                item.serialCode === selectedItem.serialCode &&
                                item.storeCode === selectedItem.storeCode &&
                                item.channel === selectedItem.channel
                            );
                            if (index > -1) {
                                this.returnResults.splice(index, 1);
                            }
                        });

                        // 清空选中项
                        this.returnSelectedItems = [];

                        // 如果没有剩余项目，关闭弹框
                        if (this.returnResults.length === 0) {
                            this.showReturnDialog = false;
                        }

                        // 刷新页面数据
                        this.loadData();
                    } else {
                        this.$message.error(res.content || res.message || '归还失败');
                    }
                }).catch((error) => {
                    this.returnConfirmLoading = false;
                    console.error('归还失败:', error);
                    this.$message.error('归还失败，请稍后重试');
                });
            }).catch(() => { });
        },

        submit() {
            // 表单验证
            this.$refs.borrowed.validate((valid) => {
                if (!valid) {
                    this.$message.error('请检查表单填写是否完整');
                    return;
                }

                // 验证是否有借出明细
                if (!this.dto.apps || this.dto.apps.length === 0) {
                    this.$message.warning('请添加借出明细');
                    return;
                }

                // 验证明细数量是否有效
                const invalidItems = this.dto.apps.filter(item => !item.stockNumber || item.stockNumber <= 0);
                if (invalidItems.length > 0) {
                    this.$message.warning('请检查明细中的数量是否有效');
                    return;
                }

                // 调用后端接口保存
                const loadingInstance = this.$loading({
                    lock: true,
                    text: '正在保存...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                this.$kaung.fetch({
                    url: '/StockBills/CreateBorrow',
                    method: 'post',
                    data: { bill: this.dto.borrowed, bounds: this.dto.apps }
                }).then((res) => {
                    loadingInstance.close();
                    if (res.code === 200) {
                        this.$message.success('保存成功');

                        // 保存成功后跳转或刷新数据
                        if (res.data && res.data.billCode) {
                            // 如果返回了单号，更新当前单号并切换到查看模式
                            this.dto.borrowed.billCode = res.data.billCode;
                            this.$router.replace({
                                query: {
                                    ...this.$route.query,
                                    billCode: res.data.billCode,
                                    mode: 'view'
                                }
                            });
                        } else {
                            // 返回列表页面
                            this.back();
                        }
                    } else {
                        this.$message.error(res.content || res.message || '保存失败');
                    }
                }).catch((error) => {
                    loadingInstance.close();
                    console.error('保存失败:', error);
                    this.$message.error('保存失败，请稍后重试');
                });
            });
        },
        printForms() {
            let printData = [];

            let that = this;
            //this.companyName = this.companys.filter(function (q) { return q.id == that.dto.borrowed.companyID })[0].companyName;
            //this.companyName = this.companys.filter(function (q) { return q.id == that.bill.companyID })[0].companyName;
            const company = findCompanyById(this.dto.borrowed.companyID, this.companys);
            this.companyName = company ? company.companyName : '';

            let title = '借货业务单';
            let dataList = [];
            if (this.tabName == 'preTable') {
                dataList = this.dto.apps;
                title += '[预借出货品]';
            } else if (this.tabName == 'outTable') {
                dataList = this.dto.outs;
                title += '[已借出货品]';
            } else if (this.tabName == 'retTable') {
                dataList = this.dto.rets;
                title += '[已退回货品]';
            }
            title += "<br>";

            let total = 0;
            for (let i = 0; i < dataList.length; i++) {
                let row = dataList[i];

                total += row.stockNumber;
                printData.push({
                    '序号': (i + 1),
                    '渠道': row.channel,
                    '库房': row.storeName || row.storeCode,
                    '批次号': (row.brandSerialCode || ''),
                    '系统款号': row.detailCode,
                    '品牌款号': (row.brandModelCode || ''),
                    '证书编号': (row.certNumber || ''),
                    '名称': (row.detailName || '').length > 10 ? row.detailName.substr(0, 10) + '...' : row.detailName,
                    '数量': row.stockNumber,
                    '货重': row.weight,
                    '金重': row.goldWeight,
                    '金单价': row.goldInPrice,
                    '规格': row.unitName,
                    '备注': (row.remark || '')
                });
            }

            title += this.companyName + "<span style='float:right'>" + this.dto.borrowed.billDate + "</span>" + "<br>";
            title += '[' + this.dto.borrowed.billType + ']';

            title += "(货品" + dataList.length + "件,合计数量" + total + "个) " + "<span style='float:right'>" + this.dto.borrowed.billCode + "</span>";
            title += "<br>";

            title += "<span style='font-size:0.5em;float:right; margin-bottom:10px;'>";
            title += "[操作： " + (this.dto.borrowed.handoverName || this.dto.borrowed.createUserName) + "]、";
            title += "[交接： " + (this.dto.borrowed.reviewerName || "无") + "]、";
            title += "[复核： " + (this.dto.borrowed.operatorName || "无") + "]、";
            title += "[财务： " + (this.dto.borrowed.financerName || "无") + "] ";
            title += "</span>";

            printJS({
                header: '<h3 class="">' + title + '</h3>',
                printable: printData,
                properties: ['序号', '渠道', '库房', '批次号', '系统款号', '品牌款号', '证书编号', '名称', '数量', '货重', '金重', '金单价', '规格', '备注'],
                type: 'json',
                gridHeaderStyle: 'font-size:0.35em;font-weight:bold;border: 1px solid #ccc;white-space:nowrap',
                gridStyle: 'padding:1px 2px;',
                style: 'table tr td{font-size:0.35em;border: 1px solid #ccc;text-align:center;white-space:nowrap }'
            })
        }
    },
    mounted() {
        // 加载字典数据
        this.$kaung.dictionary("stock", "store").then(res => this.dict.stores = res);
        this.$kaung.dictionary("stock", "channel").then((res) => { this.dict.channels = res; });
    },
    created() {
        this.apiUrl = process.env.VUE_APP_BASEURL;

        this.$kaung.companys().then((res) => {
            this.companys = res;
        });

        this.billCode = this.$route.query.billCode || this.$route.query.id;
        if (this.billCode) {
            this.loadData();
        }
        else {
            this.$kaung.fetch({ url: '/StockBound/GetBillCode', method: 'get', params: { BillType: this.dto.borrowed.billType, Prev: 'JH' } }).then(res => {
                this.dto.borrowed.billCode = res.data || '';
                this.dto.borrowed.operatorName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                this.dto.borrowed.createUserName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                this.dto.borrowed.companyID = this.$store.getters.getUserInfo.companyID || '';
                this.dto.borrowed.billDate = this.$util.fmtDate(new Date(), 'yyyy-MM-dd');
            })
        }
    },
    computed: {
        isEdit() { return this.$route.query.billCode && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
    },
};
</script>
<style scoped></style>